module.exports = __webpack_public_path__ + "static/media/05-homepage5.27a07289.png";